import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from '../../core/shared/dto/dto-service/entity-service-registry';
import {XxCarPilotBrandCommentService} from './service/api/xx-car-pilot-brand-comment.service';
import {XxAutosaveFocusMockService} from './service/api/xx-autosave-focus-mock.service';

export const X_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['xx.XxSimpleTestEntity', {route: '/xx/xxSimpleTestEntities'}],

            // TM-1000002003: comment sandbox fixture (recording B) — mvs-object-comments in isolation.
            // XxCarPilotBrand: minimal host entity the comments are attached to (route-only, pure CRUD;
            // the test page reads/creates it only through mvs-search-entity + generic CRUD).
            ['xx.XxCarPilotBrand', {route: '/xx/xxCarPilotBrands'}],
            // XxCarPilotBrandComment: TRAP — this entry MUST carry `service:`. A route-only registration
            // resolves to a plain MvsCrudService via MvsCoreService.getCrudService(), which does not
            // implement MvsApiCrudServiceCommentsInterface; mvs-object-comments' duck-typed
            // checkLinkedEntityService() then fails and the component refuses with "The used service is
            // not compatible!" (console only, no UI error — renders silently empty). See
            // xx.entity-provider.spec.ts for the invariant that guards this.
            ['xx.XxCarPilotBrandComment',
                {route: '/xx/xxCarPilotBrandComments', service: XxCarPilotBrandCommentService}],

            // TM-1000002003: autosave-focus POC (route xx/test/autosave-focus). The `service:` is the
            // whole point — XxAutosaveFocusMockService answers get/update/create/delete/template
            // entirely in memory with a settable latency, so the POC needs no backend. A route-only
            // entry would resolve to a plain MvsCrudService and send real HTTP to an endpoint that
            // does not exist. The route is still declared because MvsCrudService's constructor takes
            // one, and everything the mock does NOT override would use it.
            ['xx.XxAutosaveFocusMock',
                {route: '/xx/autosaveFocusMock', service: XxAutosaveFocusMockService}],

            // TM-1000001960: Clean-Core External Side-Car — QL flatten demo entities
            // XxPerson: host entity whose rows are flattened with external side-car fields.
            ['xx.XxPerson', {route: '/xx/xxPersons'}],
            // XxPersonData: INTERNAL typed side-car instance of a person (unique per person+type). Needed
            // as a registry entry because the "Berufe (TAA)" playground tab edits it through a generic
            // CRUD form, and MvsCoreService.getCrudService resolves the REST route from here.
            ['xx.XxPersonData', {route: '/xx/xxPersonDatas'}],
            // XxPersonExternalFlatType: type-level schema; holds the set of TypeFields for one assignment.
            ['xx.XxPersonExternalFlatType', {route: '/xx/xxPersonExternalFlatTypes'}],
            // XxPersonExternalFlatTypeField: individual configurable field within a FlatType.
            ['xx.XxPersonExternalFlatTypeField', {route: '/xx/xxPersonExternalFlatTypeFields'}],
            // cc.ExternalParty: registry of external parties providing side-car schemas.
            ['cc.ExternalParty', {route: '/cc/externalPartys'}],
            // cc.ExternalPartyAssignment: binds a host entity type to a specific ExternalParty schema.
            ['cc.ExternalPartyAssignment', {route: '/cc/externalPartyAssignments'}],

            // Form-Logic Playground (route xx/form-logic). Both instance families are registered
            // because the page renders the SAME scenario through each of them: XxGenericTest has a
            // Java XxGenericTestForm, XxGenericTestNoForm has none, which is what makes "configuration
            // beats code" visible. Without a registry entry MvsCoreService.getCrudService returns null
            // and the form dies with "DtoType not found" before any logic could run.
            ['xx.XxGenericTest', {route: '/xx/xxGenericTests'}],
            ['xx.XxGenericTestNoForm', {route: '/xx/xxGenericTestNoForms'}],
            // The type rows the scenarios are configured on, and their generic field definitions.
            ['xx.XxGenericTestType', {route: '/xx/xxGenericTestTypes'}],
            ['xx.XxGenericTestTypeField', {route: '/xx/xxGenericTestTypeFields'}],
        ] as EntityServiceEntry[],
        multi: true
    }
];
